import React, { useState, useRef } from 'react';
import '../styles/FloatingIcon.scss';

const FloatingIcon = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isLeaving, setIsLeaving] = useState(false);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const leaveTimeoutRef = useRef(null);

  const handleMouseEnter = () => {
    if (leaveTimeoutRef.current) {
      clearTimeout(leaveTimeoutRef.current);
    }
    if (!isRedirecting) {
      setIsLeaving(false);
      setIsHovered(true);
    }
  };

  const handleMouseLeave = () => {
    if (!isRedirecting) {
      setIsLeaving(true);
      leaveTimeoutRef.current = setTimeout(() => {
        setIsHovered(false);
        setIsLeaving(false);
      }, 800); // Tiempo de la animación de salida
    }
  };

  const handleClick = (e) => {
    e.preventDefault();

    // Activar estado de redirección
    setIsRedirecting(true);

    // Activar las flores si no están activas
    if (!isHovered) {
      setIsHovered(true);
    }

    // Esperar 2 segundos para mostrar la animación, luego redirigir
    setTimeout(() => {
      window.location.href = './shop';
    }, 2000);
  };

  return (
    <>
      {isHovered && (
        <div className={`flower-container ${isLeaving ? 'flower-container--leaving' : ''}`}>
          {generateFlowers().map((flower) => (
            <img
              key={flower.id}
              src="/assets/icon.png"
              alt=""
              className="flower-floating"
              style={{
                left: `${flower.x}%`,
                top: `${flower.y}%`,
                '--rotation': `${flower.rotation}deg`,
                '--scale': flower.scale,
                '--opacity': flower.opacity,
                '--delay': `${flower.delay}s`,
              }}
            />
          ))}
        </div>
      )}
      <div
        className="floating-icon"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleClick}
        role="button"
        tabIndex={0}
      >
        <img
          src="/assets/icon.png"
          alt="Botanical Collection Icon"
          className="floating-icon__image"
        />
        <span className="floating-icon__text">
          {isRedirecting ? 'Redirigiendo...' : (isHovered ? 'Comprar ahora' : 'N.01-Botanical Collection')}
        </span>
      </div>
    </>
  );
};

// Generar posiciones de flores según cuadrantes
const generateFlowers = () => {
  const flowers = [];

  // Matriz de densidad: 4 filas x 5 columnas
  // 1 = muchas flores, 0 = sin flores
  const densityGrid = [
    [0, 0, 0, 0, 0], // Fila superior (0-25%)
    [1, 0, 0, 0, 1], // Fila medio-superior (25-50%)
    [1, 0.3, 0, 0.3, 1], // Fila medio-superior (25-50%)
    [1, 1, 0, 1, 1], // Fila medio-superior (25-50%)
    [1, 1, 0.2, 1, 1], // Fila medio-inferior (50-75%)
    [1, 1, 1, 1, 1], // Fila inferior (75-100%)
  ];

  const rows = 6;
  const cols = 5;
  const flowersPerCell = 5; // Número base de flores por celda con densidad 1

  let flowerCount = 0;

  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < cols; col++) {
      const density = densityGrid[row][col];

      if (density === 0) continue;

      // Calcular los límites del cuadrante
      const xMin = (col / cols) * 100;
      const xMax = ((col + 1) / cols) * 100;
      const yMin = (row / rows) * 100;
      const yMax = ((row + 1) / rows) * 100;

      // Generar flores en este cuadrante
      const numFlowers = flowersPerCell * density;

      for (let i = 0; i < numFlowers; i++) {
        const x = xMin + Math.random() * (xMax - xMin);
        const y = yMin + Math.random() * (yMax - yMin);
        const randomRotation = -30 + Math.random() * 60;
        const randomScale = 0.7 + Math.random() * 0.6;
        const randomDelay = Math.random() * 1.5;

        flowers.push({
          id: `flower-${row}-${col}-${i}`,
          x: x,
          y: y,
          rotation: randomRotation,
          scale: randomScale,
          delay: randomDelay,
          opacity: 0.5 + Math.random() * 0.5,
        });

        flowerCount++;
      }
    }
  }

  return flowers;
};

export default FloatingIcon;
